export const showSidebarLeftRoute = [
  "settings-user-management",
];

export const promotionSidebarMenu = [
  {
    id: 1,
    route: "/promotions",
    title: "Scheduled Promotions",
    icon: "TrelloIcon",
  },
  // {
  //   id: 2,
  //   route: "",
  //   title: "Scheduled Promotions",
  //   icon: "CalendarIcon",
  // },
  {
    id: 3,
    route: "/promotions/deposit-match",
    title: "Deposit Match Offers",
    icon: "PercentIcon",
  },
  {
    id: 4,
    route: "/promotions/money-back-specials",
    title: "Money Back Specials",
    icon: "RotateCcwIcon",
  },
  // { id: 5, route: "", title: "Free Bet Offers", icon: "GiftIcon" },
  {
    id: 6,
    route: "/promotions/odd-boost",
    title: "Odds Boost",
    icon: "ZapIcon",
  },
  {
    id: 7,
    route: "/promotions/price-promotions",
    title: "Price Promotions",
    icon: "TagIcon",
  },
  {
    id: 8,
    route: "/promotions/game",
    title: "Game",
    icon: "AirplayIcon",
  },
  // { id: 8, route: "", title: "Analytics", icon: "TrelloIcon" },
  // { id: 9, route: "", title: "Compliance", icon: "ShieldIcon" },
  // { id: 10, route: "", title: "Settings", icon: "SettingsIcon" },
];

export const marketingSidebarMenu = [
  {
    id: 1,
    route: "",
    title: "Dashboard",
    icon: "TrelloIcon",
  },
  {
    id: 2,
    route: "/marketing/banners",
    title: "Banner Management",
    icon: "ImageIcon",
  },
  {
    id: 3,
    route: "/marketing/sms-campaigns",
    title: "SMS Campaigns",
    icon: "MessageCircleIcon",
  },
  {
    id: 4,
    route: "/marketing/push-notifications",
    title: "Push Notifications",
    icon: "BellIcon",
  },
  {
    id: 5,
    route: "/marketing/in-app-messaging",
    title: "In-App Messaging",
    icon: "MessageSquareIcon",
  },
  {
    id: 6,
    route: "/marketing/segments-customer",
    title: "Customer Segments",
    icon: "UsersIcon",
  },
  // {
  //   id: 7,
  //   route: "",
  //   title: "Analytics",
  //   icon: "ActivityIcon",
  // },
  // { id: 8, route: "", title: "Data & Integrations", icon: "DatabaseIcon" },
  // { id: 9, route: "", title: "Settings", icon: "SettingsIcon" },
];

export const reportSidebarMenu = [
  {
    isTitle: true,
    title: "BETTING REPORTS",
  },
  {
    id: 24,
    title: "Unresolved Liability",
    icon: "AlertIcon",
    route: "/report/betting/unresolved-liability",
  },

  {
    isTitle: true,
    title: "FINANCIAL REPORTS",
  },
  {
    id: 21,
    title: "Upcoming Break Expiries",
    icon: "AlertCircleIcon",
    route: "/report/financial/upcoming-break-expiries",
  },
  {
    id: 22,
    title: "250k+ Deposits (AML)",
    icon: "AlertOctagonIcon",
    route: "/report/financial/250k-plus-deposits",
  },
  {
    id: 23,
    title: "User Balances at Date",
    icon: "HistoryIcon",
    route: "/report/financial/user-balances-at-date",
  },

  {
    isTitle: true,
    title: "PERFORMANCE",
  },
  {
    id: 25,
    title: "BDM Bonus Bets",
    icon: "AwardIcon",
    route: "/report/performance/bdm-bonus-bets",
  },
  {
    id: 26,
    title: "Product Profitability",
    icon: "BarChart3Icon",
    route: "/report/performance/product-profitability",
  },
  {
    id: 27,
    title: "Bonus GGR by User",
    icon: "TrendingUpIcon",
    route: "/report/performance/bonus-ggr-by-user",
  },

  {
    isTitle: true,
    title: "SYSTEM",
  },
  {
    id: 28,
    title: "User Transaction History",
    icon: "ListIcon",
    route: "/report/system/user-transaction-history",
  },
  {
    id: 29,
    title: "BDM Birthdays Today",
    icon: "GiftIcon",
    route: "/report/system/bdm-birthdays-today",
  },
];
